import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { leaflet as ll } from "./dependencies.js";
export function leaflet(_x) {
  return _leaflet.apply(this, arguments);
}

function _leaflet() {
  _leaflet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(require) {
    var L, link;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return require(ll.resolve());

          case 2:
            L = _context.sent;

            if (L._style) {
              _context.next = 10;
              break;
            }

            link = document.createElement("link");
            link.rel = "stylesheet";
            _context.next = 8;
            return require.resolve(ll.resolve("dist/leaflet.css"));

          case 8:
            link.href = _context.sent;
            L._style = document.head.appendChild(link);

          case 10:
            return _context.abrupt("return", L);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _leaflet.apply(this, arguments);
}